type DateRangeLike = {
  startDate: string | null;
  endDate: string | null;
};

export function getCorrectDateRange<T extends DateRangeLike>(
  period: unknown,
  fallback: T
): T {
  const candidate = period as Partial<T> | undefined;

  return candidate &&
    typeof candidate.startDate === 'string' &&
    typeof candidate.endDate === 'string'
    ? ({ startDate: candidate.startDate, endDate: candidate.endDate } as T)
    : fallback;
}

export function keepExistingIds(
  savedIds: string[] | undefined,
  actualIds: Iterable<string>
): string[] {
  const actualSet = new Set(actualIds);

  return (savedIds ?? []).filter((id) => actualSet.has(id));
}

export function readPersistedJson<T>(key: string): T | null {
  const raw = window.localStorage.getItem(key);

  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

export function writePersistedJson(key: string, value: unknown): void {
  window.localStorage.setItem(key, JSON.stringify(value));
}
